module.exports = __webpack_public_path__ + "static/media/location_icon.cad046a5.svg";